__turbopack_context__.v({
  "container": "jgh-ha_container",
  "dashedBorder": "jgh-ha_dashedBorder",
  "fillParentWidth": "jgh-ha_fillParentWidth",
  "loader": "jgh-ha_loader",
});
